import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSectionFormAction,
  updateSectionFormAction,
} from "../../Actions/Section&FieldAction/SectionFieldAction";
import SectionFieldsModal from "../../Modal/Section&FieldModal/SectionFieldsModal";
import { TbInputCheck, TbNewSection } from "react-icons/tb";
import { FaPlus } from "react-icons/fa6";
import FieldsModal from "../../Modal/Section&FieldModal/FieldsModal";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../Loading/LoadingPage";
import { FaEdit } from "react-icons/fa";
import { GrUpdate } from "react-icons/gr";
import { RxCross1 } from "react-icons/rx";

const SectionScreen = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const dispatch = useDispatch();
  const getSectionForms = useSelector((state) => state.getSectionForms);
  const { sectionForms, loading } = getSectionForms;
  const [isOpenFieldModal, setIsOpenFieldModal] = useState(false);
  const [sectionFormId, setSectionFormId] = useState(null);
  const [indexx, setIndexx] = useState(null);
  const [updateState, setUpdateState] = useState({
    id: "",
    title: "",
  });
  useEffect(() => {
    dispatch(getSectionFormAction());
  }, []);
  const handleUpdate = () => {
    if (updateState.title == "") {
      return;
    } else {
      dispatch(updateSectionFormAction(updateState.id, updateState.title));
      setIndexx(null);
    }
  };
  const handleClose=()=>{
    setIndexx(null)
  }
  const navigate = useNavigate();
  return (
    <div className="m-auto w-[98%]">
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent ">
          <div className="flex justify-between gap-2 px-2 items-center">
            <div className="flex gap-1 items-center font-bold text-blue-600">
              <TbNewSection />
              <p>Section Form</p>
            </div>
            <div className="mt-1">
              <button
                className="btn-primary flex gap-2 items-center"
                onClick={() => setIsOpenModal(true)}
              >
                <p>Add</p>
                <FaPlus />
              </button>
            </div>
          </div>
          <div className="parent-table w-full">
            <table className="w-full">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sectionForms?.map((sectionForm, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {indexx == index ? (
                        <td>
                          <input
                            type="text"
                            className="input w-full"
                            placeholder="Title"
                            onChange={(e) =>
                              setUpdateState({
                                ...updateState,
                                title: e.target.value,
                              })
                            }
                            value={updateState.title}
                          />
                        </td>
                      ) : (
                        <td>{sectionForm.title}</td>
                      )}
                      <td className="w-40">
                        {indexx == index ? (
                          <div className="flex gap-2">
                            <button
                              className="btn-indigo group "
                              onClick={handleUpdate}
                            >
                              update
                              <p className=" duration-500 group-hover:rotate-180">
                                <GrUpdate />
                              </p>
                            </button>
                            <button onClick={handleClose} className="btn-red group ">
                              close
                              <p className=" duration-500 group-hover:rotate-180">
                                <RxCross1 />
                              </p>
                            </button>
                          </div>
                        ) : (
                          <div className="flex gap-2">
                            <button
                              onClick={() => {
                                setSectionFormId(sectionForm.id);
                                setIsOpenFieldModal(true);
                              }}
                              className="btn-info flex gap-2 items-center"
                            >
                              Add Fields <TbInputCheck />
                            </button>

                            <button
                              onClick={() =>
                                navigate("/showFields/" + sectionForm.id)
                              }
                              className="btn-primary flex gap-2 items-center"
                            >
                              View Fields <TbInputCheck />
                            </button>

                            <button
                              onClick={() => {
                                setIndexx(index);
                                setUpdateState({
                                  ...updateState,
                                  id: sectionForm.id,
                                  title: sectionForm.title,
                                });
                              }}
                              className="btn-warning flex gap-2 items-center"
                            >
                              Edit <FaEdit />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {isOpenModal && (
        <SectionFieldsModal closeModal={() => setIsOpenModal(false)} />
      )}
      {isOpenFieldModal && (
        <FieldsModal
          sectionFormId={sectionFormId}
          closeModal={() => setIsOpenFieldModal(false)}
        />
      )}
    </div>
  );
};

export default SectionScreen;
